var definitionListTerm = 'fx_e395032e_68urh50';

export { definitionListTerm };
//# sourceMappingURL=definitionListTerm.vanilla.mjs.map
